/* eslint-disable new-cap */

import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import OrbitingSprite from './OrbitingSprite';

export default class DestructableMeteor extends OrbitingSprite {
  /**
   * 
   * @param {Phaser.Scene} game 
   * @param {*} x 
   * @param {*} y 
   */
  constructor(game, x, y) {
    super();
    this.game = game;
    this.x = x;
    this.y = y;

    this.brokenRockPieces = [];
    this.particleLifeSpan = 500;
    this.particleExplosionSpeed = 500;

    this.container = game.add.container(0, 0);
    this.container.x = x;
    this.container.y = y;

    this.wholeMeteor = game.add.sprite(0, 0, Images.DEFAULT_ATLAS, 'spaceRock');
    this.wholeMeteor.setOrigin(.5);
    this.container.add(this.wholeMeteor);

    this.brokenRockPieces.push(game.add.sprite(-19, -19, Images.DEFAULT_ATLAS, 'brokenRock1'));
    this.brokenRockPieces.push(game.add.sprite(16, -19, Images.DEFAULT_ATLAS, 'brokenRock2'));
    this.brokenRockPieces.push(game.add.sprite(18, 10, Images.DEFAULT_ATLAS, 'brokenRock3'));
    this.brokenRockPieces.push(game.add.sprite(-2, 21, Images.DEFAULT_ATLAS, 'brokenRock4'));
    this.brokenRockPieces.push(game.add.sprite(-22, 8, Images.DEFAULT_ATLAS, 'brokenRock5'));

    for (let i = 0; i < this.brokenRockPieces.length; i++) {
      this.brokenRockPieces[i].setOrigin(.5);
      this.brokenRockPieces[i].alpha = 0;
      this.container.add(this.brokenRockPieces[i]);
    }

    if (this.game.isWidescreen) {
      this.container.setScale(.85);
      this.wholeMeteor.setScale(.85);
    }

    if (!this.game.metorEmitter || !this.game.metorEmitter?.active) {
      const particles = this.game.add.particles(Images.DEFAULT_ATLAS);

      this.game.metorEmitter = particles.createEmitter(
        {
          frame: ['Particle0000', 'Particle0001', 'Particle0002', 'Particle0003', 'Particle0004'],
          x: 500,
          y: 100,
          speed: this.particleExplosionSpeed,
          lifespan: this.particleLifeSpan,
          alpha: { start: 1, end: 0 },
          quantity: 10,
          scale: 0.2,
          frequency: 500,
          on: false
        }
      );
    }

    const particles = this.game.add.particles(Images.DEFAULT_ATLAS);

    this.game.metorEmitter = particles.createEmitter(
      {
        frame: ['Particle0000', 'Particle0001', 'Particle0002', 'Particle0003', 'Particle0004'],
        x: 500,
        y: 100,
        speed: this.particleExplosionSpeed,
        lifespan: this.particleLifeSpan,
        alpha: { start: 1, end: 0 },
        quantity: 10,
        scale: 0.2,
        frequency: 500,
        on: false
      }
    );

    this.sprite = this.container;
  }

  Explode() {
    this.wholeMeteor.alpha = 0;
    this.floatingEnabled = false;

    for (let i = 0; i < this.brokenRockPieces.length; i++) {
      this.game.physics.add.existing(this.brokenRockPieces[i]);
      this.brokenRockPieces[i].body.velocity.x = this.brokenRockPieces[i].x * 20;
      this.brokenRockPieces[i].body.velocity.y = this.brokenRockPieces[i].y * 20;
      this.brokenRockPieces[i].alpha = 1;

      Tweens.addTween(this.brokenRockPieces[i], this.particleLifeSpan,{ angle: 40, alpha: 0 }, Phaser.Math.Easing.None);
    }

    const bounds = this.wholeMeteor.getBounds();

    if (this.sprite.body) {
      this.game.metorEmitter.setSpeed(this.brokenRockPieces[0].x * 20);
    }
    else {
      this.game.metorEmitter.setSpeed(800);
    }
    this.game.metorEmitter.emitParticleAt(bounds.centerX, bounds.centerY, 14);

    this.game.time.addEvent(500, () => {this.Destroy();});
  }

  Destroy() {
    if (this.emitter !== null) this.emitter.destroy();
    this.sprite.destroy();
    this.container.destroy();
    for (let i = 0; i < this.brokenRockPieces.length; i++) {
      this.brokenRockPieces[i].destroy();
    }
  }

  GetParticleLifeSpan() {
    return this.particleLifeSpan;
  }

  GetSprite() {
    return this.sprite;
  }
}